import React, { useEffect, useState } from "react";
import { Box, Button, Typography, Backdrop, FormControl } from "../../imports/muiImport";

import BasicBtn from "../../components/button/BasicBtn";
import OtpInput from 'react18-input-otp';
import CircularProgress from '@mui/material/CircularProgress';
import "./MobileOTPStyle.css";
import ErrorMsg from "../../components/errorMsg/ErrorMsg";
const OTPComponent = (props) => {
    const { phone, onVerifyOtp, onResendOtp, loading = false, isResendAvailable = false, purpose = "Verify OTP", isResetOtp } = props;
    const [otp, setOtp] = useState("");

    // ✅ Alert state
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('error');


    const handleChange = (value) => setOtp(value);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (otp.length === 6) {
            onVerifyOtp(phone, otp);
        }
    };

    const resetOTP = () => {
        setOtp("");
    }

    useEffect(() => { resetOTP() }, [isResetOtp]);

    return (
        <>
            <Box
                component={"div"}
                sx={{
                    mt: 3,
                }}
            >
                <Box textAlign="center">
                    <Typography variant="h5" fontWeight={400}>
                        {purpose}
                    </Typography>

                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                        Code sent to: <strong>+91 {phone}</strong>
                    </Typography>

                    <FormControl component="form" onSubmit={handleSubmit} >
                        <OtpInput
                            value={otp}
                            onChange={handleChange}
                            numInputs={6}
                            className="digitInput"
                            shouldAutoFocus
                            isInputNum
                            containerStyle={{
                                justifyContent: "center", gap: "4px"
                            }}
                        />

                        <Box mt={2}>
                            <BasicBtn
                                type="submit"
                                name="Verify OTP"
                                color="secondary"
                                smColor="primary"
                                disabled={otp?.length !== 6}
                                sx={{ mt: 3 }}
                            />
                        </Box>
                    </FormControl>

                    <Box mt={2}>
                        <Typography variant="body2">
                            Didn’t get the code?
                            <Button
                                variant="text"
                                disabled={!isResendAvailable}
                                onClick={() => onResendOtp(phone)}
                                sx={{ textTransform: "capitalize", fontWeight: 500 }}
                            >
                                Resend
                            </Button>
                        </Typography>
                    </Box>


                </Box>

                <Backdrop open={loading} sx={{ color: "#fff", zIndex: 999 }}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Box>
        </>
    );
};

export default OTPComponent;
